var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"outlined":""}},[_c('div',{staticClass:"subtitle-1 font-weight-bold mb-3 primary--text"},[_vm._v("Detalle de Educación / Grado de Instrucción")]),_c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"s-col-form",attrs:{"cols":"12","md":"6"}},[_c('s-select-definition',{attrs:{"def":1066,"label":"Nivel Educativo obtenido*","addCustom":_vm.$fun.isAdmin(),"customFields":[
                    {
                      key: 'DedDescription',
                      label: 'País',
                      required: true,
                      cols: 6,
                    },
                    {
                      key: 'DedFormat',
                      label: 'Gentilicio',
                      required: true,
                      cols: 6,
                    },
                    {
                      key: 'DedAbbreviation',
                      label: 'Abreviación',
                      required: true,
                      cols: 6,
                    },
                    {
                      key: 'DedHelper',
                      label: 'Cód. T4 Sunat',
                      required: true,
                      cols: 6,
                    },
                    {
                      key: 'DedHelper2',
                      label: 'Cód. T26 Sunat',
                      required: true,
                      cols: 6,
                    },
                  ]},on:{"input":_vm.emitValue},model:{value:(_vm.levelID),callback:function ($$v) {_vm.levelID=$$v},expression:"levelID"}})],1),_c('v-col',{staticClass:"s-col-form",attrs:{"cols":"12","md":"6"}},[_c('s-select-educational-institution',{attrs:{"id":"EdiCode","label":"Institución Educativa*"},on:{"input":_vm.onInstitutionChange},model:{value:(_vm.ediCode),callback:function ($$v) {_vm.ediCode=$$v},expression:"ediCode"}})],1),_c('v-col',{staticClass:"s-col-form",attrs:{"cols":"12","md":"6"}},[_c('s-select-educational-major',{attrs:{"id":"EdmCode","label":"Carrera Profesional*","edi-code":_vm.ediCode,"disabled":!_vm.ediCode},on:{"input":_vm.emitValue},model:{value:(_vm.edmCode),callback:function ($$v) {_vm.edmCode=$$v},expression:"edmCode"}})],1),_c('v-col',{staticClass:"s-col-form",attrs:{"cols":"12","md":"3"}},[_c('s-text',{attrs:{"type":"number","label":"Año de Ingreso","maxlength":"4"},on:{"input":_vm.emitValue},model:{value:(_vm.yearAdmission),callback:function ($$v) {_vm.yearAdmission=$$v},expression:"yearAdmission"}})],1),_c('v-col',{staticClass:"s-col-form",attrs:{"cols":"12","md":"3"}},[_c('s-text',{attrs:{"type":"number","label":"Año de Egreso (o actual)","maxlength":"4"},on:{"input":_vm.emitValue},model:{value:(_vm.yearGraduation),callback:function ($$v) {_vm.yearGraduation=$$v},expression:"yearGraduation"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }